module.exports = __webpack_public_path__ + "static/media/not-logedin.5c20b53d.svg";